import { request } from "../../utils/config"

export const CREATE_CATEGORY = async (data) => {
  const response = await request({
    url: "productCategory",
    method: "POST",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const UPDATE_CATEGORY = async (data) => {
  const response = await request({
    url: "productCategory",
    method: "PUT",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const DELETE_CATEGORIES = async (data) => {
  const response = await request({
    url: "productCategory",
    method: "DELETE",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const DELETE_CATEGORY = async (id: string) => {
  const response = await request({
    url: `productCategory?id=${id}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
